module.exports = __webpack_public_path__ + "static/media/5.fa15d577.svg";